import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import dt from '../../../shared/theme';
import useFundsStateStore from '../common/funds-state-hook';
import { Description, Name, Results } from './hero-components/styles';

const Banner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  z-index: 210;
  background-color: #F1F3F8;
  min-height: 186px;
  padding: 0 28px;
  color: ${props => dt(props).theme.bodyBackgroundColor};
  font-weight: ${props => dt(props).theme.fontWeightBold};

  ${props => dt(props).theme.isXLarge && `
    padding: 0 calc(50% - 476px);
  `};

  ${props => dt(props).theme.isXXLarge && `
    padding: 0 calc(50% - 600px);
  `};

  ${props => dt(props).theme.isMobile && `
    padding: 0 20px;
  `};
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const AssetClass = styled.span`
  text-transform: none;
`;

const SName = styled(Name)`
  text-transform: capitalize;
`;

const fundTypeToLabel = fundType => (
  {
    'managed-funds': 'managed funds',
    etfs: 'ETFs',
    lics: 'LICs',
    lits: 'LITs',
  }[fundType] || 'funds'
);

const BreadcrumbContainer = styled.div`
  background-color: #F1F3F8;
  padding: 0 28px;

  ${props => dt(props).theme.isXLarge && `
    padding: 0 calc(50% - 476px);
  `};

  ${props => dt(props).theme.isXXLarge && `
    padding: 0 calc(50% - 600px);
  `};

  ${props => dt(props).theme.isMobile && `
    padding: 0 20px;
    overflow-x: auto;
    scrollbar-color: #8ea3b5;
  `};
`;

const buildHeader = fundType => {
  if (!fundType) {
    return 'Discover Managed Investments';
  }

  return `discover ${fundTypeToLabel(fundType)}`;
};

const buildDescription = fundType => {
  if (!fundType) {
    return "Detailed research and information available for Australia's leading Managed Funds, ETFs, LICs and LITs";
  }

  return `Detailed research and information available for Australia's leading ${fundTypeToLabel(fundType)}`;
};

export default function Hero() {
  const totalResults = useFundsStateStore(state => state.totalResults);
  const fundType = useFundsStateStore(state => state.appliedFilters.fundTypes[0]);
  const assetClasses = useFundsStateStore(state => state.assetClasses);
  const appliedFiltersAssetClasses = useFundsStateStore(state => state.appliedFilters.assetClasses);
  const breadcrumb = useFundsStateStore(state => state.breadcrumb);

  const resultsText = totalResults !== null ? `${totalResults} Result${totalResults === 1 ? '' : 's'}` : null;
  const appliedfiltersTitles = (assetClasses || [])
    .filter(ac => _.indexOf(appliedFiltersAssetClasses, ac.id) >= 0)
    .map(ac => ac.title);
  const assetClassLabel = appliedfiltersTitles.length === 1 ? `invested in ${appliedfiltersTitles[0]}` : '';

  return (
    <div>
      <BreadcrumbContainer dangerouslySetInnerHTML={{ __html: breadcrumb }} />
      <Banner>
        <Container>
          {!!resultsText && <Results>{resultsText}</Results>}
          <SName>
            {buildHeader(fundType)}
            {!!assetClassLabel && <AssetClass>{` ${assetClassLabel}`}</AssetClass>}
          </SName>
          <Description>
            {buildDescription(fundType)}
          </Description>
        </Container>
      </Banner>
    </div>
  );
}
